export default {
  unsaved: {
    title: 'Tallennetaanko muutokset?',
    description: 'Olet tehnyt tähän vaiheeseen muutoksia, joita ei ole vielä tallennettu.',
    discard: 'Hylkää',
    save_and_continue: 'Tallenna ja jatka',
  },
  title: 'Määritä ravintolasi',
  nav: {
    completed: 'Valmis',
    locked: 'Palveluntarjoajasi hoitaa tämän',
    aria_label: 'Käynnistysvaiheet',
    step_label: 'Vaihe {{number}}',
    section_label: 'Käynnistys',
    back_to_home: 'Takaisin kotiin',
  },
  owner_invite: {
    hint: 'Haluatko mieluummin, että ravintolan omistaja viimeistelee asetukset itse? Kutsu hänet, niin hän jatkaa siitä, mihin jäit.',
    sent: 'Kutsu lähetetty vastaanottajalle {{name}} ({{email}}) {{date}}.',
  },
  footer: {
    step_of: 'Vaihe {{current}}/{{total}}',
  },
  buttons: {
    next_task: 'Seuraava tehtävä',
    cancel: 'Peruuta',
    back: 'Takaisin',
    next: 'Jatka',
    save: 'Tallenna',
    exit: 'Poistu asetuksista',
    retry: 'Yritä uudelleen',
  },
  errors: {
    progress_load_failed: 'Tämän ravintolan asetusten edistymistä ei voitu ladata.',
    linked_company_unavailable: 'Tämä linkki on ravintolaan, jota et voi avata, joten olet nykyisessä ravintolassasi.',
  },
  placeholder: {
    title: 'Tämä vaihe on tulossa pian',
    description: 'Ohjatun toiminnon runko ja edistymisen seuranta ovat valmiit. Tämä vaihe rakennetaan seuraavaksi.',
  },
  new_restaurant: {
    title: 'Uusi ravintola',
    menu: {
      title: 'Ruokalista',
      description: 'Demo ohittaa käyttöönoton, joten tuo sen ruokalista nyt.',
    },
    demo: {
      title: 'Uusi demo',
      description: 'Testaukseen tarkoitettu demoravintola – se ohittaa suurimman osan käyttöönotosta.',
      label: 'Luo demo',
    },
    description: 'Kerro, missä tämä ravintola sijaitsee. Etsimme sen Google Mapsista.',
  },
  location: {
    edit_description: 'Päivitä ravintolan sijainti.',
    cta: 'Luo ravintola',
    section: {
      address: 'Perustiedot',
      group: 'Brändi',
      group_description: 'Kuuluuko tämä sijainti jo olemassa olevaan brändiisi?',
    },
    form: {
      name: {
        label: 'Ravintolan nimi',
        placeholder: 'Hae ravintolaasi…',
        help: 'Aloita kirjoittaminen etsiäksesi tätä ravintolaa Google Mapsista.',
      },
      address: {
        label: 'Katuosoite',
        placeholder: 'Katu ja numero',
      },
      city: {
        label: 'Kaupunki',
      },
      zip_code: {
        label: 'Postinumero',
      },
      country: {
        label: 'Maa',
      },
      region: {
        label: 'Osavaltio / alue',
        placeholder: 'Valitse osavaltio tai alue',
      },
    },
    group: {
      aria_label: 'Brändivaihtoehdot',
      deferred_hint: 'Valitset brändin nimen ja verkko-osoitteen viimeisessä vaiheessa.',
      existing: {
        title: 'Lisää olemassa olevaan brändiin',
        description: 'Toinen toimipiste brändille, jota jo ylläpidät.',
        select_label: 'Brändi',
        select_placeholder: 'Valitse brändi',
      },
      new: {
        title: 'Luo uusi brändi',
        description: 'Yksittäinen ravintola tai uuden brändin ensimmäinen toimipiste.',
      },
    },
    toasts: {
      update_failed: 'Toimipisteen tallennus epäonnistui. Yritä uudelleen.',
      created: 'Ravintola luotu',
      create_failed: 'Ravintolan luonti epäonnistui. Yritä uudelleen.',
    },
  },
  domain: {
    url_setup: {
      title: 'Verkkotilausosoite',
      description: 'Mistä asiakkaat tekevät tilauksia.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'verkkotilausdomainisi',
        title: 'Käytä yleistä verkkotunnustamme',
      },
      custom: {
        title: 'Yhdistä oma verkkotunnus',
        description: 'Käytä verkkotunnusta, joka ravintolalla jo on.',
      },
    },
    toasts: {
      save_failed: 'Verkkotilausosoitteen tallennus epäonnistui. Yritä uudelleen.',
    },
  },
  go_live: {
    subtitle: 'Tarkista, että kaikki vaiheet on tehty, ja ota sitten tilaukset käyttöön.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Vain kirjaimia, numeroita ja väliviivoja. Voit muuttaa tätä myöhemmin, mutta vanha osoite lakkaa toimimasta.',
      title: 'Verkkotilausosoite',
      description: 'Tänne asiakkaasi tekevät tilauksia. Voit muuttaa tätä myöhemmin.',
      label: 'Mukauta ravintolan nimellä',
      placeholder: 'bella-italia',
      preview: 'Tilaussivusi:',
      save: 'Tallenna URL',
      saved: 'Verkkotilausosoite tallennettu',
      save_failed: 'URL:n tallennus epäonnistui. Yritä uudelleen.',
      status: {
        checking: 'Tarkistetaan saatavuutta…',
        available: 'Vapaana',
        taken: 'Tämä URL on jo varattu',
        invalid: 'Käytä vain kirjaimia, numeroita, väliviivoja ja alaviivoja',
        error: 'Saatavuuden tarkistus epäonnistui — yritä uudelleen',
      },
    },
    domain: {
      title: 'Mukautettu verkkotunnus (valinnainen)',
      description: 'Käytä omaa verkkotunnustasi FoodAmigosin tarjoaman osoitteen sijaan.',
      add: '+ Lisää mukautettu verkkotunnus',
      hide: 'Piilota mukautettu verkkotunnus',
      label: 'Verkkotunnuksesi',
      placeholder: 'shop.ravintolani.fi',
      save: 'Tallenna',
      show_records: 'Näytä DNS-tietueet',
      hint: 'Vain tilauksiin — verkkosivustosi tarvitsee eri verkkotunnuksen. Esimerkiksi order.ravintolani.fi kaupalle ja ravintolani.fi verkkosivustolle.',
      records_after_save:
        'Kun tallennat verkkotunnuksen, näytämme tarkat tietueet, jotka lisätään DNS-tarjoajallesi — pääverkkotunnus (ravintolani.fi) ja alitunnus (order.ravintolani.fi) tarvitsevat eri tietueet.',
      saved: 'Mukautettu verkkotunnus tallennettu',
      save_failed: 'Verkkotunnuksen tallennus epäonnistui. Yritä uudelleen.',
      unconfirmed: {
        title: 'Käyttöönotto ei odota tätä verkkotunnusta',
        description:
          'Kunnes sen tietueet on vahvistettu, tilaussivu pysyy vakio-osoitteessaan, ja ravintola voi ottaa sen käyttöön siellä. Kun ne on vahvistettu — tämä voi kestää jopa 48 tuntia — verkkotunnus palvelee tilaussivua automaattisesti.',
      },
    },
    locations: {
      title: 'Vahvista toimipisteet',
      description: 'Jokainen brändisi toimipiste saa oman tilausosoitteen. Vahvista tai muokkaa niitä alla.',
      save: 'Tallenna toimipisteet',
      saved: 'Toimipisteiden URL:t tallennettu',
      save_failed: 'Yhden tai useamman toimipisteen URL:n tallennus epäonnistui. Yritä uudelleen.',
    },
    preflight: {
      title: 'Ennen käyttöönottoa',
      description: 'Suorita nämä loppuun ottaaksesi tilaukset käyttöön.',
      url_setup: 'Tilausosoite määritetty',
      online_payment: {
        your_provider: 'palveluntarjoajasi',
        payments_live: '{{title}} · valmis',
        online_payments_off: '{{title}} · ei ota vastaan verkkomaksuja',
        waiting_for_provider: '{{title}} · odottaa {{provider}}',
        hosted_not_finished: '{{title}} · viimeistele {{provider}}:n kanssa',
        action_needed: '{{title}} · toimenpide vaaditaan',
        waiting_for_partner: '{{title}} · odottaa kumppaniasi',
        not_set_up: '{{title}} · ei määritetty',
        business_details_missing: '{{title}} · lisää yritystiedot maksuja varten',
      },
    },
    failed_checks: {
      title: 'Muutama asia vaatii vielä huomiota',
      items: {
        name: 'Ravintolan nimi',
        logo_url: 'Logo',
        pictures: 'Galleriakuvat',
        menu_uploaded: 'Ruokalista',
        opening_hours: 'Aukioloajat',
        address: 'Osoite',
        storefront: 'Tilausosoite',
        payments_configured: 'Maksut',
        stripe_billing: 'Laskutus',
        test_orders: 'Testitilaus',
        google_business: 'Google Business -profiili',
        master_promo_code: 'Tervetuloa-etukoodi',
        flyers_ordered: 'Esitteet tilattu',
        identity: 'Ravintolan tyyppi ja keittiöt',
        billing_payment_method: 'Maksutapa',
        billing_license: 'Lisenssi',
        business_name: 'Yrityksen / ravintolan nimi',
        payment_method: 'Käteinen tai verkkomaksut',
        stripe_processing_fee: 'Kumppanin käsittelymaksu',
      },
      force: 'Julkaise silti',
      blocker: '(pakollinen)',
      link: 'Avaa kumppanilaskutus',
    },
    error: 'Tilausten käyttöönotto epäonnistui. Yritä uudelleen.',
    gate_hint: 'Suorita yllä oleva tarkistuslista loppuun, niin voit julkaista.',
    business_name: {
      label: 'Yrityksen / ravintolan nimi',
      help: 'Näkyy käyttöehdoissa ja tietosuojakäytännössä. Käytä nimeä, jolla yrityksesi toimii.',
      save: 'Tallenna',
      save_failed: 'Yrityksen nimen tallennus epäonnistui. Yritä uudelleen.',
      hint: 'Tallenna ensin yrityksen / ravintolan nimi.',
    },
    cash_only: {
      message:
        'Verkkomaksut ovat pois päältä — asiakkaat voivat maksaa vain käteisellä noudon tai toimituksen yhteydessä, kunnes maksuyhdyskäytävä on liitetty ja vahvistettu.',
    },
    payment_blocked: {
      title: 'Ota käteismaksut käyttöön tai määritä verkkomaksut ottaaksesi käyttöön.',
      payment_method: 'Asiakkaat tarvitsevat tavan maksaa.',
      turn_on_cash: 'Ota käteismaksut käyttöön',
      ask_partner: 'Pyydä kumppaniasi ottamaan käteismaksut käyttöön, tai',
      set_up_online: 'määritä verkkomaksut',
    },
    buttons: {
      go_live: 'Julkaise 🚀',
      finish: 'Viimeistele käyttöönotto',
    },
    celebration: {
      title: 'Olet nyt käytössä!',
      title_named: '{{name}} on nyt käytössä!',
      subtitle: 'Ravintolasi ottaa nyt vastaan tilauksia.',
      license: '{{plan}} · aktiivinen',
      license_trial: '{{plan}} · ilmainen {{date}} asti',
      finish: 'Viimeistele käyttöönotto',
    },
    service_fee: {
      title: 'Palvelumaksu',
      headline: 'Ansaitse lisätuloja veloittamatta ravintoloitasi',
      subtitle:
        'Lisää pieni palvelumaksu, jonka asiakkaat maksavat kassalla. Saat puolet. Se pysyy pois päältä, ellet ota sitä käyttöön.',
      subtitle_share:
        'Lisää pieni palvelumaksu, jonka asiakkaat maksavat kassalla. Saat {{share}}%. Se pysyy pois päältä, ellet ota sitä käyttöön.',
      tiles: {
        guest: {
          title: 'Asiakkaan maksama',
          description: 'Näytetään kassalla, kuten toimituspalveluissa.',
        },
        share: {
          title: 'Puolet sinulle',
          title_share: '{{share}}% sinulle',
          description: 'Jaa {{share}}/{{rest}} FoodAmigosin kanssa.',
        },
        choice: {
          title: 'Oma valinta',
          description: 'Pois päältä oletuksena. Muuta milloin tahansa.',
        },
      },
      preview: {
        title: 'Mitä vieraat näkisivät kassalla',
        subtotal: 'Tilauksen välisumma',
        fee: 'Palvelumaksu',
        fee_terms: '({{percentage}} %, enintään {{max}})',
        guest_pays: 'Vieras maksaa',
        split_partner: '<strong>Sinä {{amount}}</strong> per tilaus',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'Ravintolan tilauksen arvo pysyy ennallaan.',
      },
      earnings: {
        title: 'Mitä voisit ansaita tästä ravintolasta',
        orders: 'Verkkotilauksia kuukaudessa',
        average_order: 'Keskimääräinen tilaus',
        per_month: 'kuukaudessa sinulle',
        collected: '{{amount}} kerätty vierailta kuukaudessa. Osuutesi: {{share}} %. Vain arvio.',
        effective_rate: 'Tehokas palvelumaksuprosentti kaikista tilauksista: {{rate}}',
      },
      choice: {
        question: 'Lisätäänkö palvelumaksu tälle ravintolalle?',
        enabled: {
          title: 'Lisää palvelumaksu',
          recommended: 'Suositus: {{percentage}} %, enintään {{max}}',
          description: 'Vieraat maksavat pienen maksun. Sinä saat osuuden.',
        },
        skipped: {
          title: 'Ei palvelumaksua',
          description: 'Vieraat maksavat vain ruokalistan hinnat.',
        },
      },
      footer: {
        enabled:
          'Vieraat maksavat {{percentage}} %, enintään {{max}} per tilaus. Voit muuttaa tätä milloin tahansa kohdassa <settings>Tilausasetukset → Palvelumaksu</settings>.',
        skipped:
          'Ei palvelumaksua toistaiseksi. Voit muuttaa tätä milloin tahansa kohdassa <settings>Tilausasetukset → Palvelumaksu</settings>.',
      },
      enabled:
        'Palvelumaksu on nyt käytössä tässä ravintolassa, {{percentage}} %, enintään {{max}} per tilaus. Se koskee kaikkia uusia tilauksia tästä eteenpäin. Voit muuttaa tätä milloin tahansa kohdassa <settings>Tilausasetukset → Palvelumaksu</settings>.',
      enabled_partner_default:
        'Palvelumaksu on nyt käytössä tässä ravintolassa. Kumppanin oletusarvo on voimassa: {{percentage}} %, enintään {{max}} per tilaus. Se koskee kaikkia uusia tilauksia tästä eteenpäin. Voit muuttaa tätä milloin tahansa kohdassa <settings>Tilausasetukset → Palvelumaksu</settings>.',
      buttons: {
        enable: 'Ota palvelumaksu käyttöön',
        continue_without: 'Jatka ilman maksua',
      },
      skipped:
        'Tämän ravintolan vieraat eivät maksa palvelumaksua. Voit ottaa sen käyttöön milloin tahansa kohdassa <settings>Tilausasetukset → Palvelumaksu</settings>.',
      toasts: {
        save_failed: 'Palvelumaksuvalintaa ei voitu tallentaa. Yritä uudelleen.',
      },
    },
  },
  toasts: {
    save_failed: 'Muutoksia ei voitu tallentaa. Yritä uudelleen.',
    saved: 'Tallennettu',
  },
  optional: 'Valinnainen',
  identity: {
    min_cuisine_hint: 'Valitse vähintään yksi keittiötyyppi jatkaaksesi.',
    sections: {
      restaurant_type: {
        title: 'Ravintolan tyyppi',
        description: 'Minkälainen toimipaikka tämä on?',
      },
      cuisine: {
        title: 'Keittiötyypit',
        description: 'Valitse vähintään yksi.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Suositeltu',
      import: {
        title: 'Tuo alustalta',
        description: 'Tuo ruokalista GloriaFoodista, Woltista, Lieferandosta, Deliveroosta ja muista.',
      },
      manual: {
        title: 'Rakenna ruokalista alusta alkaen',
        description: 'Luo kategoriat ja tuotteet manuaalisesti ruokalistan muokkaimessa.',
      },
    },
    import: {
      title: 'Tuo olemassa olevasta alustasta',
      in_progress: {
        title: 'Tuodaan ruokalistaa…',
        description: 'Tämä kestää yleensä alle kaksi minuuttia. Viimeistelemme tämän vaiheen heti, kun se valmistuu.',
      },
      failed: {
        title: 'Tuonti ei valmistunut',
        description: 'Ruokalistan tuontia ei voitu suorittaa loppuun. Tarkista tiedot ja yritä uudelleen.',
      },
      blocked: {
        until: 'Keskeytetty, kunnes {{time}}',
        release: 'Vapauta linkki',
        released: 'Linkki vapautettu. Voit aloittaa tuonnin uudelleen.',
        release_failed: 'Linkkiä ei voitu vapauttaa. Yritä uudelleen hetken kuluttua.',
      },
      stalled: {
        title: 'Tuodaan yhä…',
        description:
          'Tuonti kestää tavallista kauemmin. Se saattaa yhä olla käynnissä taustalla — tarkista uudelleen hetken kuluttua. Uuden tuonnin aloittaminen nyt voi tuoda ruokalistan kahteen kertaan.',
      },
    },
    manual: {
      title: 'Rakenna ruokalista alusta alkaen',
      description:
        'Ruokalistan muokkain avautuu tyhjällä ruokalistalla. Tämä vaihe on valmis, kun vähintään yksi kategoria ja yksi tuote on olemassa.',
      open_editor: 'Avaa ruokalistan muokkain',
      waiting: {
        title: 'Odotetaan ensimmäistä ruokalistan tuotetta',
        description: 'Kun lisäät tuotteen ruokalistan muokkaimessa, tämä vaihe voidaan merkitä valmiiksi.',
      },
      found: {
        title: 'Ruokalistan tuotteita havaittu',
        description: 'Hienoa — voit jatkaa seuraavaan vaiheeseen.',
      },
    },
    complete: {
      title: 'Ruokalista valmis',
      description: 'Ruokalistasi on valmiina. Voit tarkistaa sen milloin tahansa ruokalistan muokkaimesta.',
    },
    buttons: {
      start_import: 'Aloita tuonti',
      importing: 'Tuodaan…',
      retry: 'Yritä tuontia uudelleen',
      check_again: 'Tarkista uudelleen',
      continue: 'Jatka',
      skip: 'Ohita toistaiseksi',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'tämä ravintola',
    location: {
      title: 'Sijainti',
      description: 'Missä ravintola sijaitsee ja mihin brändiin se kuuluu?',
    },
    identity: {
      title: 'Identiteetti',
      description: 'Ravintolan tyyppi ja keittiötyypit.',
    },
    brand: {
      title: 'Brändi',
      description: 'Logo, värit ja kuvagalleria.',
    },
    operations: {
      title: 'Sijainnin tiedot',
      description:
        'Määritä, miten {{name}} ottaa tilauksia vastaan. Tämä on vähimmäisvaatimus ennen kuin tilauksia voidaan vastaanottaa.',
    },
    menu: {
      title: 'Ruokalista',
      description:
        'Vie {{name}}:n ruokalista alustalle. Tuo se olemassa olevasta alustasta alle kahdessa minuutissa tai rakenna se alusta alkaen.',
    },
    domain: {
      title: 'Verkkotunnus',
      description: 'Verkko-osoite, jota asiakkaat käyttävät tilatessaan tästä ravintolasta.',
    },
    go_live: {
      title: 'Julkaise',
      description: 'Ota käyttöön tilaukset.',
    },
    payouts: {
      title: 'Verkkomaksu',
      description: 'Miten tämä ravintola ottaa maksuja vastaan verkossa.',
    },
    service_fee: {
      title: 'Palvelumaksu',
      description:
        'Maksavatko vieraat palvelumaksun kassalla. Voit muuttaa tätä myöhemmin kohdassa Tilausasetukset → Maksut.',
    },
    bank_account: {
      title: 'Pankkitili',
      description:
        'Minne tilitykset menevät. Ei tarpeen julkaisua varten: maksut odottavat saldolla, kunnes tili lisätään.',
    },
  },
  business_details: {
    locked:
      'Nämä tiedot on vahvistettu maksupalveluntarjoajasi kanssa. Muuttaaksesi niitä, ota yhteyttä FoodAmigosiin.',
    section: {
      title: 'Yrityksen tiedot',
    },
    fields: {
      business_type: {
        label: 'Yritysmuoto',
        options: {
          company: 'Yritys (GmbH, UG, Oy, Inc — rekisteröity oikeushenkilö)',
          individual: 'Yksityishenkilö (omistat ja johdat liiketoimintaa henkilökohtaisesti)',
        },
      },
      owner_first_name: { label: 'Omistajan etunimi' },
      owner_last_name: { label: 'Omistajan sukunimi' },
      legal_name: {
        label: 'Virallinen yrityksen nimi',
        individual:
          'Johdat liiketoimintaa henkilökohtaisesti, joten omistajan nimeä käytetään virallisena yrityksen nimenä.',
      },
      legal_address: { label: 'Rekisteröity osoite' },
      legal_city: { label: 'Kaupunki' },
      legal_state: { label: 'Osavaltio tai maakunta' },
      legal_zip_code: { label: 'Postinumero' },
      legal_country: { label: 'Maa' },
      tax_id: {
        generic: 'Vero- tai rekisterinumero',
        personal: 'Vain neljä viimeistä numeroa näytetään. Jätä se ennalleen, jos et halua muuttaa numeroa.',
        hint: 'Esimerkiksi {{example}}.',
        invalid: 'Tämä ei vastaa tämän maan ja yritysmuodon tavallista muotoa, esimerkiksi {{example}}.',
      },
      is_vat_registered: { label: 'Tämä yritys on arvonlisäverovelvollinen' },
      vat_id: {
        label: 'ALV-tunnus',
        help: 'Alkaa tunnuksella {{country}}, jota seuraa 8–12 kirjainta tai numeroa.',
        invalid: 'ALV-tunnuksen tulee alkaa tunnuksella {{country}}, jota seuraa 8–12 kirjainta tai numeroa.',
        help_unprefixed: 'ALV- tai verorekisterinumerosi sellaisena kuin se on myönnetty.',
        invalid_unprefixed: 'Tämä ei vaikuta ALV-tunnukselta: käytä 5–25 kirjainta tai numeroa.',
      },
    },
    toasts: {
      save_failed: 'Yrityksen tietoja ei voitu tallentaa. Yritä uudelleen.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Lyhyt nimi',
        placeholder: 'esim. Amigo Pizza',
        tooltip: 'Lyhyempi näyttönimi, jota käytetään Storefrontissa ja kuiteissa.',
      },
      primary_color: {
        label: 'Pääväri',
        invalid: 'Anna kelvollinen heksaväri, esim. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Nimi',
      short_name_hint: 'Käytetään Storefrontissa, kuiteissa ja ilmoituksissa.',
      logo_and_colour: 'Logo ja pääbrändiväri',
      logo: 'Lataa logo',
      logo_hint: 'Jos jätät tämän tyhjäksi, käytetään brändisi logoa.',
      gallery: 'Galleriakuvat',
      gallery_hint: 'Lisää enintään {{max}} kuvaa ravintolastasi. Järjestä vetämällä.',
      gallery_count: '{{count}}/{{max}} lisätty',
    },
    toasts: {
      image_uploaded: 'Kuva ladattu',
      image_upload_failed: 'Kuvaa ei voitu ladata. {{error}}',
      save_failed: 'Brändin tietoja ei voitu tallentaa. Yritä uudelleen.',
    },
  },
  operations: {
    contact: {
      title: 'Yhteystiedot',
      description: 'Käytetään tilausilmoituksiin ja asiakasviestintään.',
      phone: {
        label: 'Ravintolan puhelinnumero',
        placeholder: '+49 30 1234567',
        invalid: 'Anna täydellinen kansainvälinen puhelinnumero, esim. +49 30 1234567',
      },
      email: { label: 'Ravintolan sähköposti', placeholder: 'orders@restaurant.com' },
    },
    methods: {
      title: 'Tilaustavat',
      description: 'Miten asiakkaat voivat tilata ja kuinka kauan kukin tapa kestää.',
      pickup: {
        label: 'Nouto',
        prep_time: { label: 'Keskimääräinen valmistusaika (min)' },
      },
      delivery: {
        label: 'Toimitus',
        delivery_time: { label: 'Keskimääräinen toimitusaika (min)' },
        advanced_zones: 'Edistynyt alueasetus',
      },
    },
    timing: {
      title: 'Tilauksen ajoitus',
      description: 'Milloin asiakkaat voivat tilata — heti, myöhemmin tai etukäteen.',
      at_least_one: 'Ota käyttöön pikatilaukset tai ajastetut tilaukset (vähintään toinen vaaditaan).',
      asap: { label: 'Hyväksy pikatilaukset' },
      scheduled: { label: 'Hyväksy ajastetut tilaukset' },
      reminders: { label: 'Lähetä automaattinen muistutus ennen ajastetun tilauksen eräpäivää' },
      pre_order: {
        label: 'Salli ennakkotilaukset tuleville päiville',
        days: { label: 'Kuinka monta päivää etukäteen (0-31)' },
      },
    },
    tax: {
      title: 'ALV',
      description:
        'Tähän ravintolan tuotteisiin sovellettava veroprosentti. Se perustuu alueen oletusarvoon — muuta sitä vain, jos tämä ravintola veloittaa toisin.',
      rate: { label: 'ALV-kanta', placeholder: 'esim. 7' },
      dedicated: { label: 'ALV vaihtelee tuotteittain' },
    },
    hours: {
      title: 'Aukioloajat',
      description: 'Päivät ja ajat, jolloin tämä ravintola ottaa vastaan tilauksia.',
      same_every_day: 'Samat ajat joka päivä',
      split_shifts: {
        title: 'Tällä ravintolalla on jaetut aukioloajat',
        description:
          'Joillakin päivillä on useampi kuin yksi aukiolojakso (esim. lounas- ja illallisvuoro). Tämä yksinkertainen muokkain näyttää yhden jakson per päivä, joten säilytämme nykyiset aukioloaikasi ennallaan — muokkaa jaettuja vuoroja kohdassa Tilausasetukset → Aukioloajat.',
      },
    },
    toasts: {
      save_failed: 'Toiminta-asetusten tallennus epäonnistui. Yritä uudelleen.',
    },
  },
  online_payment: {
    question: 'Haluatko ottaa käyttöön verkkomaksut tälle ravintolalle?',
    yes: 'Kyllä',
    not_now: 'Ei nyt',
    declined:
      'Asiakkaat maksavat noudon tai toimituksen yhteydessä. Voit ottaa verkkomaksut käyttöön milloin tahansa Asetuksista.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Maksuja ei ole vielä määritetty kumppanitilillesi',
        description:
          'Kumppanitilisi ylläpitäjän on valittava maksujen käsittelijä ennen kuin tämä ravintola voi ottaa vastaan verkkomaksuja. Voit jatkaa muita vaiheita sillä aikaa.',
      },
    },
    continue_to_go_live: 'Jatka julkaisuun',
    platform_line: 'Tämän ravintolan maksut kulkevat FoodAmigos-maksujen kautta.',
    only_connection: 'Maksut kulkevat palvelun {{name}} kautta (ainoa yhdistetty palveluntarjoaja).',
    partner_issue: {
      title: 'Kumppanisi {{partner}} on saatettava maksupalvelun asennus loppuun',
      description:
        'Heidän maksupalveluntarjoajansa ei voi vielä liittää ravintoloita. Olemme ilmoittaneet heille — tietosi on tallennettu, palaa tänne kun he vahvistavat sen valmiiksi.',
      retry_hint: 'Kun ongelma on korjattu, jatka taas palveluntarjoajan luo, niin yritämme uudelleen.',
      open_settings: 'Avaa maksuyhdyskäytävän asetukset',
    },
    connect_another: 'Yhdistä toinen palveluntarjoaja',
    checking: 'Tarkistetaan palveluntarjoajalta {{provider}}…',
    checking_generic: 'Tarkistetaan maksupalveluntarjoajalta…',
    retry: 'Yritä uudelleen',
    not_set_up: {
      title: 'Maksupalveluntarjoajaa ei ole vielä yhdistetty',
      description:
        'Kumppanisi yhdistää maksupalveluntarjoajan tähän ravintolaan. Kun se on tehty, voit viimeistellä asetukset täällä.',
    },
    choice: {
      title: 'Mitä yhdistetyistä palveluntarjoajistasi tämän ravintolan tulisi käyttää?',
      primary: 'Ensisijainen',
      confirm: 'Käytä tätä palveluntarjoajaa',
      cancel: 'Peruuta',
    },
    using: 'Käytössä: {{name}}',
    change: 'Vaihda',
    payout_details: {
      title: 'Yritystiedot tilityksiä varten',
      description: 'Maksupalveluntarjoaja vaatii nämä yrityksesi vahvistamiseksi ja tilitysten lähettämiseksi.',
      business_type: {
        company: {
          title: 'Yritys',
          description: 'GmbH, UG, Ltd, Inc — rekisteröity oikeushenkilö',
        },
        individual: {
          title: 'Yksityishenkilö',
          description: 'Omistat ja pyörität liiketoimintaa itse',
        },
      },
      registered_address: 'Rekisteröity osoite',
      legal_address: 'Katuosoite',
      legal_state: 'Osavaltio / alue',
      vat_id: 'ALV-tunnus',
      optional: '(valinnainen)',
      fill_first: 'Täytä ensin yllä olevat tilityksiä varten tarvittavat yritystiedot.',
    },
    stripe_account: {
      question: 'Mitä Stripe-tiliä tämän ravintolan tulee käyttää?',
      options: {
        recommended: 'Suositeltu',
        new: {
          title: 'Luo uusi Stripe-tili',
          description: 'Luomme tilin Stripe-alustallesi, ja ravintola suorittaa Stripen tarkistukset.',
        },
        existing: {
          title: 'Yhdistä olemassa oleva Stripe-tili',
          description: 'Ravintolalla on jo Stripe-tili alustallasi.',
        },
      },
      existing: {
        title: 'Yhdistä olemassa oleva Stripe-tili',
        description: 'Syötä tilin tunnus Stripe-hallintapaneelista (Connected accounts). Se alkaa merkkijonolla acct_.',
        look_up: 'Hae tili',
        link: 'Yhdistä tämä tili',
        not_charging_yet:
          'Stripe ei ole vielä ottanut maksuja käyttöön tällä tilillä. Voit yhdistää sen nyt; ravintola voi vastaanottaa verkkomaksuja, kun Stripe on vahvistanut tilin.',
        confirm_pause: 'Keskeytä tämän ravintolan verkkomaksut, kunnes Stripe on vahvistanut tilin',
        unsaved_details:
          'Kirjoittamiasi maksutietoja ei ole tallennettu. Palaa valintaan ”Luo uusi Stripe-tili” tallentaaksesi ne tai yhdistä olemassa oleva tili.',
      },
      summary: {
        business_name: 'Yrityksen nimi',
        account: 'Tilin tunnus',
        type: 'Tilin tyyppi',
        country: 'Maa',
        currency: 'Valuutta',
        charges: 'Voi vastaanottaa maksuja',
        payouts: 'Voi vastaanottaa maksuja tilille',
        yes: 'Kyllä',
        no: 'Ei vielä',
      },
      types: {
        standard: 'Standard',
        express: 'Express',
        custom: 'Custom',
      },
      managed: {
        title: 'Hallinnoidaan Stripessä',
        description:
          'Tämä ravintola käyttää alustasi Stripe-tiliä {{account}}. Sen henkilöllisyyttä, pankkitiliä ja maksuja hallitaan Stripessä, ei täällä.',
        description_owner:
          'Tämä ravintola käyttää olemassa olevaa Stripe-tiliään {{account}}. Sen tunnistetiedot, pankkitili ja maksut hallitaan Stripessä, ei täällä.',
        reviewing: 'Stripe tarkistaa ravintolan tiedot.',
        pending: 'Stripe tarvitsee vielä tietoja ravintolalta.',
        pending_owner: 'Stripe tarvitsee sinulta vielä muutamia tietoja.',
        action_needed: 'Stripe ei pystynyt vahvistamaan yhtä tiedoista. Avaa Stripe korjataksesi sen.',
        owner_finishes: 'Ravintola viimeistelee tämän omalla Stripe-tilillään.',
        continue: 'Jatka Stripessä',
        open_stripe: 'Avaa Stripe Dashboard',
        disconnect: 'Katkaise tilin yhteys',
        disconnect_confirm:
          'Katkaistaanko tämän Stripe-tilin yhteys? Ravintola ei voi vastaanottaa verkkomaksuja, ennen kuin Stripe-tili yhdistetään uudelleen. Tili säilyy Stripe-alustallasi.',
      },
      errors: {
        lookup: 'Emme voineet tarkistaa tätä tiliä. Yritä uudelleen.',
        link: 'Emme voineet yhdistää tätä tiliä. Yritä uudelleen.',
        disconnect: 'Emme voineet katkaista tämän tilin yhteyttä. Yritä uudelleen.',
      },
    },
    hand_off: {
      title: 'Seuraavaksi: viimeistele asetus palvelun {{provider}} kanssa',
      description:
        '{{provider}} pyytää omistajan henkilöllisyystodistusta omassa lomakkeessaan, käyttäen yllä olevia tilitystietoja. Kestää noin 10 minuuttia. Pankkitili lisätään julkaisun jälkeen.',
      cta: 'Jatka palveluun {{provider}}',
      transition: 'Siirretään sinut palveluun {{provider}}…',
      error: 'Lomaketta {{provider}} ei voitu avata. Yritä uudelleen.',
    },
    states: {
      verified: 'Maksut ovat käytössä.',
      submitted: {
        title: 'Tiedot lähetetty palveluun {{provider}}',
        description:
          'Vahvistus kestää yleensä 1–2 arkipäivää. Lähetämme ravintolan omistajalle sähköpostia, kun se on valmis.',
        description_email:
          'Vahvistus kestää yleensä 1–2 arkipäivää. Lähetämme sähköpostin osoitteeseen {{email}}, kun se on valmis.',
        review: {
          business_type: 'Yritysmuoto',
          legal_name: 'Virallinen nimi',
          address: 'Rekisteröity osoite',
          types: {
            company: 'Yritys',
            individual: 'Yksityishenkilö',
          },
        },
      },
      incomplete: {
        title: 'Et ole vielä saanut palvelua {{provider}} valmiiksi',
        description: 'Tietosi on tallennettu — linkki on voimassa 2 päivää.',
        expired: 'Tietosi on tallennettu, mutta linkki on vanhentunut.',
        cta: 'Jatka palvelun {{provider}} kanssa',
        new_link: 'Hanki uusi linkki ja jatka',
        check_details: 'Tarkista tietoni ensin',
      },
      action_needed: {
        title: '{{provider}} tarvitsee vielä yhden asian',
        description:
          '{{provider}} ei pystynyt vahvistamaan yhtä antamistasi tiedoista. Avaa heidän lomakkeensa uudelleen korjataksesi sen.',
        cta: 'Avaa palvelun {{provider}} lomake uudelleen',
      },
    },
    connected: {
      title: 'Maksut kulkevat palvelun {{name}} kautta',
      description: 'Tämä ravintola on yhdistetty {{name}}-tiliin — muuta ei tarvitse asettaa täällä.',
      failed: 'Emme vielä pystyneet yhdistämään tätä ravintolaa palveluun {{name}}',
    },
    errors: {
      generic: 'Jotain meni pieleen. Yritä uudelleen.',
      load_failed: 'Emme pystyneet lataamaan tämän ravintolan maksuasetuksia.',
    },
  },
  bank_account: {
    section: {
      title: 'Tilityksen pankkitili',
      description: 'Tilitykset lähetetään valuutassa {{currency}}, jolla tämä ravintola ottaa maksuja vastaan.',
    },
    done: 'Takaisin hallintapaneeliin',
    load_failed: 'Emme pystyneet lataamaan tämän ravintolan pankkitiliä.',
    retry: 'Yritä uudelleen',
    no_permission: 'Vain ravintolan omistaja tai kumppani voi syöttää pankkitilin.',
    confirm_with_provider: 'Vahvista Adyenin kanssa',
    toasts: {
      save_failed: 'Pankkitiliä ei voitu tallentaa. Tarkista tiedot.',
    },
  },
  payouts: {
    finish_setup: 'Viimeistele käyttöönotto',
  },
};
